import React from "react";
import { NavLink } from "react-router-dom";
import { injectIntl } from "react-intl";
import { getClassName } from "ui-kit/utils/component";

import "./Submenu.scss";

import item0 from "./img/item0.png";
import item1 from "./img/item1.png";
import item2 from "./img/item2.png";
import item3 from "./img/item3.png";

const ccn = getClassName("Submenu");
const subNavItems = [
  {
    id: 0,
    value: "Settings",
    link: "/settings",
    src: item0
  },
  {
    id: 1,
    value: "Help",
    link: "//support.hedgedbitcoin.com/hc/en-us/",
    src: item1
  },
  {
    id: 2,
    value: "Disclosures",
    link: "/disclosures",
    src: item2
  },
];

const Submenu = ({ name, logOut, lang, intl: { formatMessage }}) => (
  <div className={ccn()}>
    <span>{name}</span>
    <ul>
      {
        subNavItems.map(item => (
          <li key={item.id}>
            <NavLink key={item.id} to={`${item.id!==1?"/":""}${item.link&&item.id!==1?lang:""}${item.link}`} className={ccn("link")} target={`${item.id!==1?"_self":"_blank"}`}>
              <img src={item.src} alt="item" />
              {formatMessage({ id: `hbc.header.submenu${item.id}`, defaultMessage: `${item.value}`})}
            </NavLink>
          </li>
        ))
      }
      <li className={ccn("logout")} >
        <span className={ccn("link")} onClick={() => {logOut()}}>
          <img src={item3} alt="Log Out" />
          {formatMessage({ id: 'hbc.header.submenu3', defaultMessage: 'Log Out'})}
        </span>
      </li>
    </ul>
  </div>
);

export default injectIntl(Submenu);



// WEBPACK FOOTER //
// ./src/components/header/submenu/Submenu.js